import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { CpMarketplaceApiService } from 'src/app/services/cp-marketplace-api.service';
import { TermsConditionsComponent } from '../terms-conditions/terms-conditions.component';
import { getTransformedDate } from '../../utils';
import { ISSUER_MESSAGES, ADMIN_MESSAGES } from 'src/app/messages';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent implements OnInit {
  corporateIdForm: FormGroup;
  fileTypes: any = ['.pdf'];
  roles = [{
    name: 'Issuer',
    value: 1
  }, {
    name: 'IPA',
    value: 2
  }, {
    name: 'Investor',
    value: 3
  }];

  instruments = [{
    name: 'Commercial Papers',
    value: 1
  }, {
    name: 'Syndicate Loans',
    value: 2
  }, {
    name: 'Non-Convertible Debentures',
    value: 3
  }];

  constructor(
    private corporateIdFormBuilder: FormBuilder,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private apiService: CpMarketplaceApiService,
    private sharedData: SharedDataService,
    private router: Router
  ) {
    this.corporateIdForm = corporateIdFormBuilder.group({
      company_name: ['', Validators.required],
      company_address: ['', Validators.required],
      communication_address: ['', Validators.required],
      official_telephone_number: [null, Validators.required],
      official_fax_number: [null, Validators.required],
      official_email_address: [null, Validators.required],
      pan_company: ['', Validators.required],
      pan_proof: ['', Validators.required],
      date_incorporation: [{ date: 1, month: 1, year: 1970 }, Validators.required],
      coi: ['', Validators.required],
      corporate_identity_number: ['', Validators.required],
      coa: ['', Validators.required],
      aoa: ['', Validators.required],
      gstin: ['', Validators.required],
      line_of_business: 'NBFC',
      legal_entity_identifier: ['', Validators.required],
      divisions: corporateIdFormBuilder.array([this.createCompanyDivisionDetails()]),
      corporate_user: corporateIdFormBuilder.array([this.createAdminUserDetails()]),
      tnc_signed: false
    });
  }

  ngOnInit() {
    this.sharedData.clearSessionStorage();
  }

  onRoleListChange(selectedRoles, index) {
    const existingCompanyDivisions = this.corporateIdForm.get('divisions') as FormArray;
    existingCompanyDivisions.controls[index].patchValue({
      roles: selectedRoles.map(role => {
        return {
          role_type: role.value
        };
      })
    });
  }

  onInstrumentChange(selectedInstruments, index) {
  }

  onCorporateIdDetailsSubmit(corporateIdDetails) {
    if (!corporateIdDetails.tnc_signed) {
      this.toastr.error(ADMIN_MESSAGES.ACCEPT_TNC);
    } else {
      corporateIdDetails.CompanyDivision =
        corporateIdDetails.divisions.map(division => this.transformCompanyDivision(division));
      corporateIdDetails.date_incorporation_company =
        getTransformedDate(corporateIdDetails.date_incorporation, null, false);

      this.apiService.corporateSignUp(corporateIdDetails).subscribe((resp: any) => {
        if (resp.corporate_id) {
          this.toastr.success(ADMIN_MESSAGES.CORPORATE_DETAILS_SUCCESS);
          this.sharedData.setCorporateSignUpData(resp);
          this.router.navigate(['/create-party-users']);
        }
      });
    }
  }

  transformCompanyDivision(divisionDetails) {
    const transformedDivision = {
      name: divisionDetails.name,
      AssociatedInstrument: [
        {
          instrument_type: 1,
          AssociatedRole: divisionDetails.roles
        }
      ]
    };
    return transformedDivision;
  }

  createCompanyDivisionDetails() {
    return this.corporateIdFormBuilder.group({
      name: ['', Validators.required],
      instrument: 1,
      roles: null
    });
  }

  addMoreCompanyDivisions() {
    const existingCompanyDivisions = this.corporateIdForm.get('divisions') as FormArray;
    existingCompanyDivisions.push(this.createCompanyDivisionDetails());
  }

  removeCompanyDivision(index) {
    const existingCompanyDivisions = this.corporateIdForm.get('divisions') as FormArray;
    existingCompanyDivisions.removeAt(index);
  }

  createAdminUserDetails() {
    return this.corporateIdFormBuilder.group({
      name: ['', Validators.required],
      pan: ['', Validators.required],
      phone_number: [null, Validators.required],
      mobile_number: [null, Validators.required],
      email: ['', Validators.required]
    });
  }

  addMoreAdminUsers() {
    const existingAdminUsers = this.corporateIdForm.get('corporate_user') as FormArray;
    existingAdminUsers.push(this.createAdminUserDetails());
  }

  removeAdminUser(index) {
    const existingAdminUsers = this.corporateIdForm.get('corporate_user') as FormArray;
    existingAdminUsers.removeAt(index);
  }

  uploadDocument(fileContent, documentName, docKeyValue) {
    const formDataRequest = new FormData();
    formDataRequest.append('files', fileContent);
    this.apiService.uploadFileAndGetToken(formDataRequest).subscribe((respKey) => {
      this.corporateIdForm.controls[docKeyValue].setValue(respKey[0]);
      this.toastr.success(`${documentName} Added`);
    });
  }

  showTncModal() {
    this.modalService.open(TermsConditionsComponent, { backdrop: 'static', keyboard: false });
  }

}
